<template>
    <div>
        <v-text-field class="mr-4" prepend-icon="fa-filter" :placeholder="'Filter'|translate" v-model="search" clearable single-line/>
        <v-treeview v-if="equipTree"
                    :search="search"
                    :items="equipTree"
                    activatable
                    item-key="id"
                    open-on-click
        >
            <template v-slot:label="{ item }">
                <span v-if="item.children.length==0">
                            <draggable v-if="!disabled" :list="[item]" :group="{ name: 'a', pull: 'clone', put:false}" :clone="cloneForDrag">
                                <v-chip :key="'b'+item.id"
                                        label
                                >
                                {{item.name}}
                                </v-chip>
                            </draggable>
                            <v-chip v-if="disabled">
                                {{item.name}}
                            </v-chip>
                </span>
                <span v-if="item.children.length>0">{{item.name}}</span>
            </template>
        </v-treeview>


    </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import {sortFloors} from '@/helper'
  export default {
    name: 'PointsDraggable',
    components: {
      draggable
    },
      props: {
          disabled: {type: Boolean, default: false},
          chartMode: {type: Boolean, default: false},
          chartLayout: {type: Object, default: null},
      },
    data () {
      return {
          childrenList:{},
          search:null,
      }
    },
    methods: {
        cloneForDrag(original){
            if(this.chartMode){
                return {
                    filters: {
                        equipment_name:original.equipment_name,
                        sensor_name:original.name
                    },
                    seriesOverrides:this.chartLayout,
                    pipeline:[],
                    offsetRange:false,
                    offsetType:"months",
                    offsetAmount:1,
                    type: "insert_series",
                    name:original.equipment_name+" - "+original.name,
                }
            } else {
                return original;
            }
        },
        findWhere(array, key, value) {
            let t = 0;
            while (t < array.length && array[t][key] !== value) {
                t++;
            }
            if (t < array.length) {
                return array[t]
            } else {
                return false;
            }
        },
        arrangeIntoTree(paths) {
            let tree = [];
            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];
                let currentLevel = tree;
                for (let j = 0; j < path.length; j++) {
                    let part = path[j];
                    let existingPath = this.findWhere(currentLevel, 'name', part);
                    if (existingPath) {
                        currentLevel = existingPath.children;
                    } else {
                        let newPart = {
                            name: part,
                            id: path.join('-')+'-'+part,
                            children: [],
                        }
                        if(this.childrenList[part]){
                            newPart.children=[...this.childrenList[part]]
                        }
                        currentLevel.push(newPart);
                        currentLevel = newPart.children;
                    }
                }
            }
            return tree;
        }


    },
      computed: {
          items() {
              let output = []
              if (!this.$store.state.pointsListStore.pointsList) return [{id: 1, name: 'loading'}]
              let id = 1
              for (let i in this.$store.state.pointsListStore.pointsList.sensors) {
                  let points = []
                  let current = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                  for (let j in this.$store.state.pointsListStore.pointsList.sensors[i]) {

                          points.push({
                              id: id,
                              children: [],
                              name: this.$store.state.pointsListStore.pointsList.sensors[i][j],
                              equipment_name: this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name,
                              facility_name: this.$store.state.pointsListStore.pointsList.facility_name
                          })
                      id++

                  }
                  points.sort((a, b) => (a.name > b.name) ? 1 : -1)
                  this.childrenList[current.equipment_name] = points
                  output.push(current)
              }
              output.sort((a, b) => (a.equipment_name > b.equipment_name) ? 1 : -1)
              return output
          },
          equipTree(){
              let equipList=this.items;
              let equipPaths=[];
              for (let equip of equipList){
                  if(equip.floor&&equip.floor!==""&&equip.floor!=="NaN"){
                      equipPaths.push(equip.floor.split('>').concat([equip.equipment_name]))
                  } else if (equip.equipment_type&&equip.equipment_type!==""&&equip.equipment_type!==equip.equipment_name){
                      equipPaths.push([equip.equipment_type,equip.equipment_name])
                  } else {
                      equipPaths.push([equip.equipment_name])
                  }
              }
              equipPaths=sortFloors(equipPaths)
              let tree=this.arrangeIntoTree(equipPaths);
              return tree;
          }
      }
  }
</script>

<style scoped>

</style>
